export default __webpack_public_path__ + "assets/todo.145a2092.png";